import { useState, useEffect, useRef, useCallback } from 'react'
import styles from '../../pages/ProductSelection.module.css'
import useProductSelectionStore from '../../stores/useProductSelectionStore'

const LineItemNotes = () => {
  const { selectedPhoto, notes, setNotes, productType } = useProductSelectionStore()
  const [isOpen, setIsOpen] = useState(false)
  const [notesMode, setNotesMode] = useState('current')
  const textareaRef = useRef(null)

  const autoResize = useCallback(() => {
    const ta = textareaRef.current
    if (ta) {
      ta.style.height = 'auto'
      ta.style.height = ta.scrollHeight + 'px'
    }
  }, [])

  const photoGuid = productType === 'multi-opening' ? undefined : selectedPhoto?.attributes?.guid

  useEffect(() => {
    if (notesMode === 'all' && photoGuid && notes._all) {
      setNotes({
        ...notes,
        [photoGuid]: notes._all
      })
    }
  }, [photoGuid, notesMode, notes._all])

  // Derive current textarea value from state
  const currentValue = notesMode === 'current' && photoGuid 
    ? (notes[photoGuid] || '') 
    : notes._all

  const handleModeChange = (e) => {
    e.stopPropagation()
    setNotesMode(e.target.value)
  }

  const handleNotesChange = (e) => {
    const key = notesMode === 'current' && photoGuid ? photoGuid : '_all'
    setNotes({ ...notes, [key]: e.target.value })
    autoResize()
  }

  return (
    <div data-ix="fade-up-1" className="accordion js-accordion">
      <div className="accordion__item js-accordion-item">
        <div className="accordion-header js-accordion-header">
          <div className={`accordion-item-2 ${styles.itemNotesHeader}`}
            onClick={() => setIsOpen(!isOpen)}>  
            <div className="icon small x2 right-margin w-embed">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentcolor"
                viewBox="0 0 256 256"
              >
                <rect width="256" height="256" fill="none" />
                <path d="M128,23.99805a104,104,0,1,0,104,104A104.12041,104.12041,0,0,0,128,23.99805Zm40,112H136v32a8,8,0,1,1-16,0v-32H88a8,8,0,0,1,0-16h32v-32a8,8,0,0,1,16,0v32h32a8,8,0,0,1,0,16Z" />
              </svg>
            </div>
            <div>Add Note</div>
          </div>
        </div>
        <div 
          data-ix="hide-on-load" 
          className={`accordion-body js-accordion-body ${isOpen ? styles.itemNotesBodyOpen : styles.itemNotesBodyClosed}`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="accordion-item-content">
            <div className="input-container add-notes">
              <div 
                className={`form-block-input w-form ${isOpen ? styles.itemNotesFormVisible : styles.itemNotesFormHidden}`}
              >
                <form
                  id="email-form"
                  name="email-form"
                  data-name="Email Form"
                  method="get"
                  className="input-wrapper"
                  onClick={(e) => e.stopPropagation()}
                >
                  <textarea
                    ref={textareaRef}
                    value={currentValue}
                    placeholder="Write note here"
                    maxLength="300"
                    id="field-6"
                    name="field-6"
                    data-name="field"
                    className="text-field-2 area w-input editing-notes"
                    style={{ resize: 'none', overflow: 'hidden' }}
                    rows={2}
                    onChange={handleNotesChange}
                  />
                </form>
                <div className="w-form-done">
                  <div>Thank you! Your submission has been received!</div>
                </div>
                <div className="w-form-fail">
                  <div>Oops! Something went wrong while submitting the form.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LineItemNotes
